import { useNavigate } from "react-router-dom";
import { DateUtil } from "../../../common/utils/date.util";
import CardAlert from "../components/CardAlert";
import Select from "../../../common/components/Select";
import { ROUTES } from "../../../core/routes/routes";
import { ALERT_CATEGORY_FILTER_OPTIONS } from "../alertCategoryFilterOptions";

function AsideContent({ alerts, filters, setFilters }) {
  const navigate = useNavigate();

  const handleClick = (category) => {
    switch (category) {
      case "mantenimiento":
        navigate(ROUTES.LIST_MAINTENANCE);
        break;
      case "capacitacion_vial":
        navigate(ROUTES.WORK_PLAN_AND_TRAINING);
        break;
      case "capacitacion_plan_anual":
        navigate(ROUTES.WORK_PLAN_AND_TRAINING);
        break;
      default:
        console.log("No action defined for this category");
    }
  };

  return (
    <div>
      <h2 style={{ fontSize: "1.25rem", marginBottom: "1rem" }}>
        Alertas <span className="badge bg-dark ms-2">{alerts.length}</span>
      </h2>
      <Select
        value={filters.category}
        onChange={({ value }) => setFilters({ ...filters, category: value })}
        options={ALERT_CATEGORY_FILTER_OPTIONS}
      />
      <div style={{ display: "flex", flexDirection: "column", gap: "1rem" }}>
        {alerts.map((alert) => (
          <CardAlert
            key={alert.id}
            title={alert.title}
            description={alert.description}
            date={DateUtil.format(alert.date)}
            category={alert.category}
            onClick={() => handleClick(alert.category)}
          />
        ))}
      </div>
    </div>
  );
}

export default AsideContent;
